export default __webpack_public_path__ + "static/17100-0ff9c3017e6dba8263d7287b8d9e2c9b.webp";